module.exports = "/desktop-app/assets/img/me.svg?0920c7432f8546385ca8e4e5be44f025";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/me.svg
// module id = YsPj
// module chunks = 1